/**
 * Reset scroll position for the SPA shell and the document.
 * Dhruv workspace scrolls inside `.workspace-content`, not the window.
 */
export function scrollAppToTop() {
  if (typeof window === 'undefined') return;

  window.scrollTo(0, 0);

  const docEl = document.documentElement;
  const body = document.body;
  if (docEl) docEl.scrollTop = 0;
  if (body) body.scrollTop = 0;

  document.querySelectorAll('.workspace-content, .parivartan-content, .main-content').forEach((el) => {
    el.scrollTop = 0;
  });
}

export default scrollAppToTop;
